import React, { useRef, useEffect } from 'react';
import { isEscapeButton } from '../../../misc/misc';
import ActionClose from '../../share/actionbar/ActionClose';
import './propertyPopup.scss';

/**
 * @param {Object} props
 * @param {number} props.width - px
 * @param {number} props.height - px
 * @param {string} props.title
 * @param {function} props.onClose - callback
 */

function PropertyPopup(props) {
	const box = useRef(null);

	useEffect(() => {
		box.current.focus();
	});

	useEffect(() => {
		const handleEscape = (event) => {
			if (isEscapeButton(event)) {
				props.onClose();
			}
		}
		window.addEventListener('keydown', handleEscape);
		return () => window.removeEventListener('keydown', handleEscape);
	}, [props]);

	const onClose = () => {
		props.onClose();
	}

	const style = {
		width: props.width,
		minHeight: props.height,
	}

	return (
		<div
			ref={box}
			className="property-popup"
			style={style}
			tabIndex="0" // HACK to close popup on outside click, consider another way
			onBlur={() => props.onClose()}
		>
			<div className="header">
				<div className="title">{props.title}</div>
				<div className="actions">
					<ActionClose onClick={onClose} />
				</div>
			</div>
			<div>
				{props.children}
			</div>
		</div>
	)
}

export default PropertyPopup;
